import { createTransform } from 'redux-persist'
import { PlanningRecordsState, initialState } from './planningRecordsSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  PlanningRecordsState,
  Omit<PlanningRecordsState, 'error'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: PlanningRecordsState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      status,
    }
  },
  {
    whitelist: ['planningRecords'],
  },
)
